import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';


import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import './fonts/fonts.css';

ReactDOM.render(<App />, document.getElementById('root'));
